import { useQuasar } from 'quasar'
import { useApplicationStore } from '@/common/stores/applicationStore'
import { watch } from 'vue'

export default function useLoading() {
  const $q = useQuasar()
  const applicationStore = useApplicationStore()

  watch(
    () => applicationStore.ready,
    (newVal) => {
      if (newVal) {
        $q.loading.hide()
        return
      }
      $q.loading.show()
    },
    {
      flush: 'post',
      immediate: true,
    },
  )
}
